// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__11ki6","title":"Images90_title__2NCze","images":"Images90_images__3DGi4"};